import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import ThankYou from 'pages/thank-you';
import CheckoutRedirect from 'pages/checkout-redirect';
// import Interviews from 'pages/interviews';
import RedirectPage from 'pages/Redirect';
const UnsubscribePage = Loadable(lazy(() => import('pages/unsubscribe')));
// pages routing
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const MaintenanceError500 = Loadable(lazy(() => import('pages/maintenance/500')));
// const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction')));
const MaintenanceComingSoon = Loadable(lazy(() => import('pages/maintenance/coming-soon')));

// render - sample page

const LpComparer = Loadable(lazy(() => import('pages/lp-comparer')));
const LpAnalysis = Loadable(lazy(() => import('pages/lp-analysis')));
const ProPage = Loadable(lazy(() => import('pages/pro-page')));
const CompetitorAnalysisList = Loadable(lazy(() => import('pages/competitors-analysis-list')));
const Tools = Loadable(lazy(() => import('pages/tools')));
const Projects = Loadable(lazy(() => import('pages/projects')));
const ProjectScenarios = Loadable(lazy(() => import('pages/project-scenarios')));
const NewProject = Loadable(lazy(() => import('pages/project/new')));
const ProjectSetup = Loadable(lazy(() => import('pages/project/setup')));
const ProjectDetails = Loadable(lazy(() => import('pages/project/details')));
const Onboarding = Loadable(lazy(() => import('pages/onboarding')));
const ProjectDashboardPage = Loadable(lazy(() => import('pages/project-dashboard')));
const SBSExamplePage = Loadable(lazy(() => import('pages/sbs-example')));
const ChatDemoPage = Loadable(lazy(() => import('pages/chat-demo')));
const AgentPage = Loadable(lazy(() => import('pages/agent')));
const PublicThreadViewer = Loadable(lazy(() => import('pages/public-thread-viewer')));

// render - applications

const UserProfile = Loadable(lazy(() => import('pages/apps/profiles/user')));
// const UserTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/user/TabPersonal')));
const UserTabPayment = Loadable(lazy(() => import('sections/apps/profiles/user/TabPayment')));
const UserTabApiKeys = Loadable(lazy(() => import('sections/apps/profiles/user/TabApiKeys')));
// const UserTabPassword = Loadable(lazy(() => import('sections/apps/profiles/user/TabPassword')));
// const AccountTabRole = Loadable(lazy(() => import('sections/apps/profiles/account/TabRole')));
const UserTabSettings = Loadable(lazy(() => import('sections/apps/profiles/user/TabSettings')));

const TermsOfUse = Loadable(lazy(() => import('pages/maintenance/TermsOfUse')));
const PrivacyPolicy = Loadable(lazy(() => import('pages/maintenance/PrivacyPolicy')));
const CancellationPolicy = Loadable(lazy(() => import('pages/maintenance/CancellationPolicy')));

const PricingPage = Loadable(lazy(() => import('pages/extra-pages/pricing').then((module) => ({ default: module.PricingPage }))));
const PricingAlpha = Loadable(lazy(() => import('pages/extra-pages/pricingAlpha')));

const PremiumRequest = Loadable(lazy(() => import('pages/extra-pages/premium-request')));

const Reviews = Loadable(lazy(() => import('pages/reviews')));
const Interviews = Loadable(lazy(() => import('pages/interviews')));

const PersonalInfo = Loadable(lazy(() => import('sections/apps/profiles/user/PersonalInfo')));

const IcpGenerator = Loadable(lazy(() => import('pages/icp-generator')));
// const AccountProfile = Loadable(lazy(() => import('pages/apps/profiles/account')));
// const AccountTabProfile = Loadable(lazy(() => import('sections/apps/profiles/account/TabProfile')));
// const AccountTabPersonal = Loadable(lazy(() => import('sections/apps/profiles/account/TabPersonal')));
// const AccountTabAccount = Loadable(lazy(() => import('sections/apps/profiles/account/TabAccount')));
// const AccountTabPassword = Loadable(lazy(() => import('sections/apps/profiles/account/TabPassword')));
// const AccountTabSettings = Loadable(lazy(() => import('sections/apps/profiles/account/TabSettings')));
// pages routing
// const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));
// const AuthRegister = Loadable(lazy(() => import('pages/auth/register')));
// const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/forgot-password')));
// const AuthResetPassword = Loadable(lazy(() => import('pages/auth/reset-password')));
// const AuthCheckMail = Loadable(lazy(() => import('pages/auth/check-mail')));
// const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/code-verification')));

import MarketTrendsPage from 'pages/market-trends/MarketTrendsPage';

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  children: [
    // LP Analysis route - accessible without authentication
    {
      path: 'lp-analysis',
      element: <MainLayout />,
      children: [
        {
          path: '',
          element: <LpAnalysis />
        },
        {
          path: ':taskId',
          element: <LpAnalysis />
        }
      ]
    },
    // Pricing route - accessible without authentication
    {
      path: 'pricing',
      element: <CommonLayout layout="landing" />,
      children: [
        {
          path: '',
          element: <PricingPage />
        }
      ]
    },
    // Public shared reports route - accessible without authentication
    {
      path: 'agentic/shared-reports/:threadId',
      element: <CommonLayout layout="simple" />,
      children: [
        {
          path: '',
          element: <PublicThreadViewer />
        }
      ]
    },
    {
      path: 'unsubscribe',
      element: <CommonLayout layout="simple" />,
      children: [
        {
          path: '',
          element: <UnsubscribePage />
        }
      ]
    },
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        // {
        //   path: 'sample-page',
        //   element: <SamplePage />
        // },
        // {
        //   path: 'main',
        //   element: <AskpotChat />
        // },

        {
          path: 'lp',
          element: <LpComparer />
        },

        {
          path: '/market-trends',
          element: <MarketTrendsPage />
        },
        {
          path: 'interviews',
          children: [
            {
              path: '',
              element: <Interviews />
            },
            {
              path: ':taskId',
              element: <Interviews />
            }
          ]
        },
        {
          path: 'icp-generator',
          children: [
            {
              path: '',
              element: <IcpGenerator />
            },
            {
              path: ':taskId',
              element: <IcpGenerator />
            }
          ]
        },
        {
          path: 'specpricing',
          element: <PricingAlpha />
        },
        {
          path: 'request-alpha',
          element: <PremiumRequest />
        },
        {
          path: 'pro',
          element: <ProPage />
        },
        {
          path: 'competitors-history',
          children: [
            {
              path: '',
              element: <CompetitorAnalysisList />
            },
            {
              path: ':taskId',
              element: <CompetitorAnalysisList />
            }
          ]
        },
        {
          path: 'reviews',
          children: [
            {
              path: '',
              element: <Reviews />
            },
            {
              path: ':taskId',
              element: <Reviews />
            }
          ]
        },
        {
          path: 'thank-you',
          element: <ThankYou />
        },
        {
          path: 'checkout-redirect',
          element: <CheckoutRedirect />
        },
        {
          path: 'profiles',
          children: [
            // {
            //   path: 'account',
            //   element: <AccountProfile />,
            //   children: [
            //     {
            //       path: 'basic',
            //       element: <AccountTabProfile />
            //     },
            //     {
            //       path: 'personal',
            //       element: <AccountTabPersonal />
            //     },
            //     {
            //       path: 'my-account',
            //       element: <AccountTabAccount />
            //     },
            //     {
            //       path: 'password',
            //       element: <AccountTabPassword />
            //     },
            //     {
            //       path: 'role',
            //       element: <AccountTabRole />
            //     },
            //     {
            //       path: 'settings',
            //       element: <AccountTabSettings />
            //     }
            //   ]
            // },
            {
              path: 'user',
              element: <UserProfile />,
              children: [
                // {
                //   path: 'personal',
                //   element: <UserTabPersonal />
                // },
                {
                  path: 'payment',
                  element: <UserTabPayment />
                },
                {
                  path: 'api',
                  element: <UserTabApiKeys />
                },
                // {
                //   path: 'password',
                //   element: <UserTabPassword />
                // },
                {
                  path: 'settings',
                  element: <UserTabSettings />
                },
                {
                  path: 'personal',
                  element: <PersonalInfo />
                }
              ]
            }
          ]
        },
        {
          path: 'tools',
          element: <Tools />
        },
        {
          path: 'projects',
          element: <Projects />
        },
        {
          path: 'project-scenarios',
          element: <ProjectScenarios />
        },
        {
          path: 'project/new',
          element: <NewProject />
        },
        {
          path: 'project/setup',
          element: <ProjectSetup />
        },
        {
          path: 'project/:id',
          element: <ProjectDetails />
        },
        {
          path: 'onboarding',
          element: <Onboarding />
        },
        {
          path: 'project-dashboard/:projectId',
          element: <ProjectDashboardPage />
        },
        {
          path: 'sbs-example',
          element: <SBSExamplePage />
        },
        {
          path: 'chat-demo',
          element: <ChatDemoPage />
        },
        {
          path: 'agent',
          element: <AgentPage />
        },
        {
          path: 'agent/:threadId',
          element: <AgentPage />
        }
      ]
    },

    {
      path: '/maintenance',
      element: <CommonLayout />,
      children: [
        {
          path: 'terms',
          element: <TermsOfUse />
        },
        {
          path: 'privacy',
          element: <PrivacyPolicy />
        },
        {
          path: 'cancellation',
          element: <CancellationPolicy />
        },
        {
          path: '404',
          element: <MaintenanceError />
        },
        {
          path: '500',
          element: <MaintenanceError500 />
        },
        // {
        //   path: 'under-construction',
        //   element: <MaintenanceUnderConstruction />
        // },
        {
          path: 'coming-soon',
          element: <MaintenanceComingSoon />
        },
        {
          path: 'redirect',
          element: <RedirectPage />
        }
      ]
    }
  ]
};

export default MainRoutes;
